module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00049-fs8.0da9794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00049-fs8.png
// module id = 202
// module chunks = 0